import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tag, theme } from 'antd';
import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * Bar above the DataGrid listing all active column filters.
 * Each filter can be removed separately, or all at once.
 */
const DataGridActiveFilters = ({
  items,
  shownCount,
  totalCount,
  onClearAll,
}) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  if (!items.length) {
    return null;
  }

  const showCounts =
    typeof shownCount === 'number' && typeof totalCount === 'number';

  return (
    <div
      className="dataGridActiveFilters"
      role="status"
      style={{
        backgroundColor: token.colorWarningBg,
        border: `${token.lineWidth}px solid ${token.colorWarningBorder}`,
        borderRadius: token.borderRadiusLG,
      }}
    >
      <span className="dataGridActiveFilters__label">
        <FilterOutlined style={{ color: token.colorWarning }} />
        {t('Aktívne filtre')}:
      </span>

      {items.map((item) => (
        <Tag
          key={item.key}
          className="dataGridActiveFilters__tag"
          style={{ borderColor: token.colorWarningBorder }}
          closable={typeof item.onClear === 'function'}
          closeIcon={<CloseOutlined aria-label={t('Zrušiť filter')} />}
          onClose={(e) => {
            e.preventDefault();
            item.onClear?.();
          }}
        >
          <b>{item.title}:</b> {item.label}
        </Tag>
      ))}

      {showCounts ? (
        <span className="dataGridActiveFilters__count">
          {t('Zobrazených {{shown}} z {{total}} záznamov', {
            shown: shownCount,
            total: totalCount,
          })}
        </span>
      ) : null}

      <Button
        className="dataGridActiveFilters__clear"
        size="small"
        icon={<CloseOutlined />}
        onClick={onClearAll}
      >
        {t('Zrušiť všetky filtre')}
      </Button>
    </div>
  );
};

DataGridActiveFilters.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.node,
      label: PropTypes.node,
      onClear: PropTypes.func,
    }),
  ).isRequired,
  shownCount: PropTypes.number,
  totalCount: PropTypes.number,
  onClearAll: PropTypes.func.isRequired,
};

export default DataGridActiveFilters;
